import { Product } from "../types/types";
import { useState, useEffect } from "react";
import { REMOVE_PRODUCT } from "./events";
import { FeatureFlags } from "@packages/feature-flags";
import { isOutOfStock, isRetiredProduct } from "./product";

export const useVisibleProducts = (
  products: Product[],
  flags: FeatureFlags,
) => {
  const [visibleProducts, setVisibleProducts] = useState(products);

  useEffect(
    function updateVisibleProductsFromProps() {
      setVisibleProducts(
        products.filter((product) => {
          if (
            (flags.hideOutOfStocks?.value && isOutOfStock(product)) ||
            (flags.hideRetiredProducts?.value && isRetiredProduct(product))
          ) {
            return false;
          }

          return true;
        }),
      );
    },
    [products, flags.hideOutOfStocks, flags.hideRetiredProducts],
  );

  useEffect(function subscribeToRemoveProductEvents() {
    const handleRemoveProduct = (event: Event) => {
      const removeEvent = event as CustomEvent<{ productId: string }>;
      const removedProductId = removeEvent.detail?.productId;

      if (!removedProductId) {
        return;
      }

      setVisibleProducts((currentProducts) =>
        currentProducts.filter(
          (product) => product.aliases?.pimProductId !== removedProductId,
        ),
      );
    };

    window.addEventListener(REMOVE_PRODUCT, handleRemoveProduct);

    return function unsubscribeFromRemoveProductEvents() {
      window.removeEventListener(REMOVE_PRODUCT, handleRemoveProduct);
    };
  }, []);

  return visibleProducts;
};
